import { generateUtilityClass, generateUtilityClasses } from '@mui/material';

export function getInfoMessageUtilityClass(slot: string) {
  return generateUtilityClass('O2InfoMessage', slot);
}

const infoMessageClasses = generateUtilityClasses('O2InfoMessage', ['root', 'icon', 'controls']);

export default infoMessageClasses;
